import { render, staticRenderFns } from "./comercial_gestion.vue?vue&type=template&id=0fd7e6e1&"
import script from "./comercial_gestion.vue?vue&type=script&lang=js&"
export * from "./comercial_gestion.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/tempos21/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!module.hot.data) {
      api.createRecord('0fd7e6e1', component.options)
    } else {
      api.reload('0fd7e6e1', component.options)
    }
    module.hot.accept("./comercial_gestion.vue?vue&type=template&id=0fd7e6e1&", function () {
      api.rerender('0fd7e6e1', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Modules/Map/Details/comercial_gestion.vue"
export default component.exports


//////////////////
// WEBPACK FOOTER
// ./src/components/Modules/Map/Details/comercial_gestion.vue
// module id = jNxZ
// module chunks = 0